class MarkerWithLabelFactory {
    static initMarkerWithLabel(google) {
        class MarkerWithLabel {
            constructor({ position, map, labelContent, draggable = false, style }) {
                this.marker = new google.maps.marker.AdvancedMarkerElement({
                    position,
                    map,
                    // title: labelContent,
                    gmpDraggable: draggable,
                });

                this.marker.isVisible = true;
                this.labelDiv = document.createElement('div');
                this.labelDiv.classList.add('marker-label');
                this.labelDiv.classList.add('fitting-label');
                this.labelDiv.innerHTML = labelContent;
                this.labelDiv.style = style;

                this.marker.content = this.labelDiv;

                this.initEvents();

                // Custom setVisible function
                this.marker.setVisible = (visible) => {
                    this.marker.isVisible = visible;
                    if (this.marker.element) {
                        this.marker.element.style.setProperty('display', visible ? 'block' : 'none', "important");
                    }
                    if (this.labelDiv) {
                        this.labelDiv.style.setProperty('display', visible ? 'block' : 'none', "important");
                    }
                };
            }

            initEvents() {
                this.marker.addListener('gmp-click', (event) => {
                    google.maps.event.trigger(this, 'gmp-click', event);
                });

                this.marker.addListener('dragstart', (event) => {
                    google.maps.event.trigger(this, 'dragstart', event);
                });

                this.marker.addListener('drag', (event) => {
                    google.maps.event.trigger(this, 'drag', event);
                });

                this.marker.addListener('dragend', (event) => {
                    google.maps.event.trigger(this, 'dragend', event);
                });
                
                this.marker.content.addEventListener('mouseover', (event) => {
                    google.maps.event.trigger(this, 'mouseover', event);
                });
                
                this.marker.content.addEventListener('mouseleave', (event) => {
                    google.maps.event.trigger(this, 'mouseleave', event);
                });

                this.marker.addListener('visible_changed', () => {
                    this.setVisible(this.marker.isVisible);
                });
            }

            setVisible(visible) {
                this.marker.setVisible(visible);
            }
        }

        return MarkerWithLabel;
    }
}
export default MarkerWithLabelFactory;
